import { Dispatch, SetStateAction, useState } from "react"
import FormErrors from "components/formParts/formErrors"
import { useTranslation } from "react-i18next"
import { CustomInputGroups } from "types"
import { filterInputName } from "utils/filter"
import TextInput from "components/inputs/textInput"
import useLayout from "hooks/useLayout"
import Form from "components/forms/form"
import { ReactComponent as SaveIcon } from "assets/icons/save.svg"
import { ReactComponent as CloseIcon } from "assets/icons/close.svg"
import Button from "components/inputs/button"
import ButtonGroup from "components/buttons/buttonGroup"
import Section from "components/layout/section"

interface EditCustomInputGroupFormProps {
    setGroups: Dispatch<SetStateAction<CustomInputGroups>>
    setCustomInputGroupOrder: Dispatch<SetStateAction<string[]>>
    groups: CustomInputGroups
    groupName: string
}

const EditCustomInputGroupForm: React.FC<EditCustomInputGroupFormProps> = ({
    setGroups,
    groups,
    setCustomInputGroupOrder,
    groupName
}) => {

    const { t } = useTranslation()

    const [errors, setErrors] = useState<string[]>([]);
    const [name, setName] = useState<string>(groupName)

    const {
        closeDialog
    } = useLayout()

    // Handle form submission.
    const handleSubmit = () => {
        // Check if the name is the same as the current name.
        if (name === groupName) {
            closeDialog()
            return
        }
        // Check if the name is already in use and not the same as the current name.
        if (Object.keys(groups).includes(name)) {
            setErrors([t('nameAlreadyExists')])
            return
        }
        // Update group name.
        let newGroups = { ...groups }
        newGroups[name] = newGroups[groupName]
        delete newGroups[groupName]
        setGroups(newGroups)
        // Update the group name in the group order array.
        // Note that no reordering is done.
        setCustomInputGroupOrder(order => {
            return order.map(o => o === groupName ? name : o)
        })
        // Close the dialog.
        closeDialog()
    }

    // Handle name change.
    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let targetVal = filterInputName(e.target.value, false, 30, true)
        setName(targetVal)
    }

    // Handle keydown event for Enter key
    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            handleSubmit()
        }
    }

    // Return the JSX.
    return (
        <div
            className={`group`}
            onKeyDown={handleKeyDown}>
            <Section>

            <TextInput label={t('name')} value={name} onChange={handleNameChange} required />

            <ButtonGroup>
                <Button wideOnMobile type="button" design="primary" onClick={handleSubmit}><SaveIcon /><span>{t('buttonSave')}</span></Button>
                <Button wideOnMobile type="button" design="white" onClick={closeDialog}><CloseIcon /><span>{t('buttonCancel')}</span></Button>
            </ButtonGroup>

            {errors.length > 0 && <FormErrors errors={errors} />}
            </Section>
        </div>
    )

}

export default EditCustomInputGroupForm



